export class EndorsementsDataResponse {
    constructor(
        public endorsements: Endorsements[]
    ) { }
}
export class Endorsements{
    id:string;
    value:string;
}    

export class KnREndorsementsGridRow {
    policyEndorsementsId: number;
    description: string;    
    isBlank: boolean;
    constructor() {}
  }
  
  export class KnREndorsementsGrid {
    endorsementsData: KnREndorsementsGridRow[];
  }
  
  export class KnRSaveMiscellaneousChangesModel {
    PolicyTxnId: number;
    PolicyId: number;
    PolicyNum?: string;
    PolicyTxnNum: number;
    TxnStatusCode?: string;
  }
  